var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2446 8.26125L11.0868 8.26086C10.7266 8.26086 10.4346 8.55282 10.4346 8.91305V11.5191C10.4346 11.8793 10.7266 12.1713 11.0868 12.1713H15.6807C15.1777 13.4768 14.2388 14.5701 13.0409 15.2648L14.9998 18.6558C18.142 16.8385 19.9998 13.6498 19.9998 10.0804C19.9998 9.57215 19.9623 9.20883 19.8874 8.79973C19.8304 8.48891 19.5606 8.26125 19.2446 8.26125Z",
    fill: "#167EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 16.0869C7.75185 16.0869 5.7892 14.8586 4.7351 13.0409L1.34424 14.9953C3.06982 17.9861 6.3024 20 10.0001 20C11.814 20 13.5256 19.5116 15.0001 18.6605V18.6558L13.0412 15.2648C12.1452 15.7845 11.1083 16.0869 10.0001 16.0869Z",
    fill: "#12B347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.6605V18.6558L13.0411 15.2648C12.1451 15.7845 11.1083 16.087 10 16.087V20C11.8139 20 13.5256 19.5116 15 18.6605Z",
    fill: "#0F993E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91305 9.99999C3.91305 8.89183 4.21547 7.85507 4.73504 6.95909L1.34418 5.00464C0.488359 6.47444 0 8.1814 0 9.99999C0 11.8186 0.488359 13.5255 1.34418 14.9953L4.73504 13.0409C4.21547 12.1449 3.91305 11.1082 3.91305 9.99999Z",
    fill: "#FFD500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 3.91305C11.4661 3.91305 12.8128 4.43398 13.8646 5.30051C14.1241 5.51426 14.5012 5.49883 14.7389 5.26113L16.5854 3.41465C16.8551 3.14496 16.8359 2.70352 16.5478 2.45359C14.7855 0.924727 12.4925 0 10.0001 0C6.3024 0 3.06982 2.01395 1.34424 5.00465L4.7351 6.9591C5.7892 5.14141 7.75185 3.91305 10.0001 3.91305Z",
    fill: "#FF4B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8645 5.30051C14.124 5.51426 14.5012 5.49883 14.7389 5.26113L16.5854 3.41465C16.855 3.14496 16.8358 2.70352 16.5477 2.45359C14.7854 0.924688 12.4925 0 10 0V3.91305C11.466 3.91305 12.8127 4.43398 13.8645 5.30051Z",
    fill: "#D93F21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ef9044bf0a4122db9e1a9b031abb5296.svg";
export { ForwardRef as ReactComponent };